import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { MuiButton } from '../../../../../components'
import { MAGNET_SCORE_IMAGE, LEGEND_COLOR_MAP_V2 } from '../../../../../constants'

const RIGHT_CONTENT = '220px'

export const GraphContentWrapper = styled(Box)(`
  width: 100%;
  display: flex;
  flex-direction: column;
  & .contentText {
    background:#fff;
  }

  &.showRowLevel2 {
    border-bottom: 10px #fff solid;
    position:relative;
  }
  &.showRowLevel2 .graphRowDetails {
    background: #fff;
  }
  &.showRowLevel2 .graphRowDetails:empty { display: none; }
  &.showRowLevel2 .contentText {
    border-bottom:0 !important;
  }
  &.showRowLevel2 > div:last-child > div {
    border-bottom:0 !important;
    position: relative;
  }
`)

export const GraphContent = styled(Box)(`
    width: 100%;
    display: flex;
    &.brandImageryRowProgression.brandImageryRowProgression .list {
        margin-left:0;
    }
    &:first-of-type {
       & .list {
       }
    }
    &:last-child {
       & .contentText {
       }
    }
`)

export const ContentText = styled(Box)(
  (props) => `
    width: ${RIGHT_CONTENT};
    min-width: ${RIGHT_CONTENT};
    text-align: right;
    display: flex;
    flex-direction:column;
    justify-content: center;
    border-top: 2px solid #F5F5F5;
    padding-right: 10px;
    & .title {
        font-size: 1rem;
        font-weight: 400;
    }
    & .percent {
        font-size: 1rem;
        font-weight: 600;
    }
    & .percent b {
        font-weight: 600;
    }
    &.showEdit_true {
        padding: 8px 40px 8px 0;
        position:relative;
        justify-content: flex-start;
    }
    &.showEdit_true button {
        position:absolute;
        top: 6px;
        right: 3px;
    }
    &.showEdit_true .arrowBtn svg path {
        fill: #095BBD;
    }
    & .hideP {
        display:none !important;
    }

    position:relative;
    display: flex;
    justify-content: flex-start;
    padding-top: 10px;

    & .btnExpand {
      position: absolute;
      right:0;
      top:5px;
    }
`
)

export const GraphRow = styled(Box)(`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    min-height: 50px;
    border-top: 2px solid #F5F5F5;
`)

export const GraphRowDetails = styled(Box)(`
    display: flex;
    width: 35px;
    justify-content: center;
    align-items: center;
    height: 30px;

    & > button {
        position: absolute;
        top: 0;
        right: 0;
        height:35px;
    }
`)

export const BrandImageryRowInsightsWrapper = styled(Box)(`
    display: block;
    border-left: 10px solid transparent;
    padding: 0;
    margin: 0px -10px;
    width: calc(100% + 20px);
    outline: 1px solid #ADADAC;
    border-right: 10px solid #fff;
    border-top: 1px #fff solid;
    margin-top: 1px;
`)

export const BrandImageryRowInsights = styled(Box)(`
    background: #fff;
    & * {
        font-size:14px;
    }
    & .pptSubHeading {
        display:none;
    }
`)

export const BrandImageryRowInsightsHeading = styled(Box)(`
    font-size: 14px;
    font-weight: 600;
    position: relative;
    height: 40px;
    line-height: 50px;

    & button {
      right:0;
      top:7px;
    }
`)

export const IconButtonWrapper = styled(MuiButton)(`
    position: absolute;
    right: 8px;
    top: 0px;
`)

export const InsightsRteContWrap = styled(Box)(`
    display: block;
    width: 100%;
    max-height: 165px;
    width:100%;
    overflow: auto;
    border: 1px solid #E0E0E0;
    padding: 10px;
    margin:10px 0 0;
`)

export const SliderWrap = styled(Box)(
  (props) => `
  height: 28px;
  border-bottom:1px #fff solid;
  display: flex;
  align-items: center;
  position: relative;
  & .sliderValue{
    left: ${props.percent}%;
    // transform: translate(-${props.percent}%, 0px);
    position: relative;
    background:  ${props?.color};
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  & img {
    position: relative;
    left: ${props.percent}%;
    // transform: translate(-${props.percent}%, 0px);
    width: ${MAGNET_SCORE_IMAGE[props?.logoname || '']?.width || 'auto'}px;
    height: 15px;
    padding-left:3px;
  }
  ${props.percent > 50 && `
    .sliderValue{margin-left:-10px;}
  `}
  & .slider {
    -webkit-appearance: none;
    width: 100%;
    height: 12px;
    border-radius: 5px;
    background: transparent;
    outline: none;
    -webkit-transition: .2s;
    transition: opacity .2s;
    border-radius: 0;
  }
  
  & .slider:hover {
    background: ${props.disabled ? 'transparent' : '#ffffff50'};
  }
  
  & .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: ${MAGNET_SCORE_IMAGE[props?.logoname || '']?.width || 80}px;
    height: 15px;
    object-fit: contain;
    border: 0;
    background-image: url(${props?.logo});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: ${props.disabled ? 'default' : 'poiner'};
  }
  
  & .slider::-moz-range-thumb {
    appearance: none;
    width: ${MAGNET_SCORE_IMAGE[props?.logoname || '']?.width || 80}px;
    height: 15px;
    object-fit: contain;
    border: 0;
    background-image: url(${props?.logo});
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
  }
`)
